export default (() => {
    const toggle = document.querySelector('.js-sidebar-toggle');
    const expanders = Array.from(document.querySelectorAll('.account__sidebar .navigation__item.js-nav-expand > a, .account__sidebar .navigation__item:not(.js-nav-expand) .js-nav-expand'));
    const expiryNotification = document.querySelector('.account__expiry-notification-strip');
    const expiryNotificationCard = document.querySelector('.expiry-notification-card');
    const upgradeContactMaxWidth= document.querySelector('.my-membership__upgrade-contact-card--max-width');

    if (toggle) {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.account__sidebar').classList.toggle('account__sidebar--contracted');

            if (expiryNotification) {
                expiryNotification.classList.toggle('account__expiry-notification-strip--contracted');
            }

            if (expiryNotificationCard) {
                expiryNotificationCard.classList.toggle('expiry-notification-card--contracted');
            }

            if (upgradeContactMaxWidth) {
                upgradeContactMaxWidth.classList.toggle('my-membership__upgrade-contact-card--contracted');
            }
        });
    }

    expanders.forEach((expander) => {
        expander.addEventListener('click', (e) => {
            e.preventDefault();
            const navItem = expander.closest('.navigation__item');
            navItem.classList.toggle('navigation__item--expanded');
        });
    });
})();
